// Sticky help strip shown below the auth card.
export function HelpStrip() {
  return (
    <a
      href="mailto:support@ecregi.com"
      className="mx-auto mt-4 flex w-full max-w-md items-center justify-between rounded-xl border border-gray-200 bg-white px-4 py-3 text-sm text-gray-700 shadow-sm hover:bg-gray-50"
    >
      <span className="flex items-center gap-2">
        <ChatDot />
        Need help? Reach out to us at{' '}
        <span className="font-medium text-brand-700">support@ecregi.com</span>
      </span>
      <Chevron />
    </a>
  );
}

function ChatDot() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden>
      <path
        fill="#16a34a"
        d="M12 3C6.48 3 2 6.94 2 11.8c0 2.34 1.05 4.48 2.8 6.05L4 21l3.5-1.2c1.37.45 2.86.7 4.5.7c5.52 0 10-3.94 10-8.8S17.52 3 12 3z"
      />
    </svg>
  );
}

function Chevron() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" aria-hidden className="text-gray-400">
      <path fill="currentColor" d="M8.59 16.59L13.17 12L8.59 7.41L10 6l6 6l-6 6z" />
    </svg>
  );
}
